import React from "react";
import styled from "styled-components";
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { use } from "react";

const MobileWrapper = styled.div`
  width: 100vw;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-color: black;
  background: rgba(139, 139, 139, 0.7);
`;

const TitleContainer = styled.div`
  position: absolute;
  left: 0;
  top: 90%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: Roumald;
  font-size: 18px;
  text-transform: lowercase;
  color: white;
  width: 100vw;
  height: 4vh;
  background: rgba(139, 139, 139, 0.7);
  backdrop-filter: blur(10px);
  border-radius: 2vh;
`;

const TitleText = styled.div`
  padding-left: 4vw;
`;

const MenuContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100dvh;
  background: rgba(139, 139, 139, 0.7);
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
  z-index: 100;
`;

const MenuItem = styled.div`
  font-family: Roumald;
  font-size: 18px;
  text-transform: lowercase;
  color: white;
  width: 40vw;
  border-radius: 10px;
  background: rgba(139, 139, 139, 0.7);
  backdrop-filter: blur(10px);
  border-radius: 2vh;
  height: 4vh;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MenuItemText = styled.div``;

const Header = styled.div`
  position: absolute;
  top: 1vh;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  font-family: Roumald;
  color: white;
  width: max-content;
  font-size: 1.1em;
  text-transform: lowercase;
  background: black;
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 0.2em 0.75em;
  z-index: 1000;
  text-align: center;
`;

const About = styled.div`
  position: absolute;
  display: none;
  flex-direction: column;
  justify-content: center;
  width: 100vw;
  height: 100dvh;
  padding: 0 6vw;
  box-sizing: border-box;
  color: white;
  font-family: Roumald;
  font-size: 1.1em;
  line-height: 1.2;
  text-align: center;
  background: rgba(139, 139, 139, 0.7);
  backdrop-filter: blur(10px);
  z-index: 100;
  text-transform: lowercase;
`;

const AboutExtended = styled.div`
  margin-top: 2vh;
  font-size: 1em;
`;

const Project = styled.div`
  position: relative;
  align-items: center;
  font-family: cool;
  width: 100vw;
  height: 30vh;
  color: white;
  font-size: 1.5em;
`;

export default function Mobile() {
  const aboutRef = useRef();
  const menuRef = useRef();
  const projectsRef = useRef();
  const aboutExtendedRef = useRef();
  const [bgImageSrc, setBgImageSrc] = useState([]);
  const [projects, setProjects] = useState([]);
  const [videos, setVideos] = useState([]);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const url =
    "https://wordpress.ninakunzendorf.net/wp-content/uploads/2024/10/Sequence01.mp4";

  useEffect(() => {
    // Fetch wordpress post with background image for main page
    async function loadBgImage() {
      const response = await fetch(
        "https://wordpress.ninakunzendorf.net/wp-json/wp/v2/pages?acf_format=standard",
      );
      if (!response.ok) {
        // oups! something went wrong
        console.log("nothing fetched");
        return;
      }
      var bgImagePost = await response.json();
      bgImagePost = bgImagePost.find(
        (item) => item.title.rendered === "background-video",
      );
      console.log(bgImagePost.acf);
      const videoUrls = [
        bgImagePost.acf.video1.link,
        bgImagePost.acf.video2.link,
        // bgImagePost.acf.video3.link,
      ];
      setVideos(videoUrls);
      // setBgImageSrc(bgImagePost._embedded["wp:featuredmedia"][0].source_url);
    }

    // Fetch all projects from wordpress REST API
    async function loadProjects() {
      const response = await fetch(
        "https://wordpress.ninakunzendorf.net/wp-json/wp/v2/project?acf_format=standard",
      );
      if (!response.ok) {
        // oups! something went wrong
        return;
      }
      const loadedProjects = await response.json();
      console.log(loadedProjects.length + " projects have been loaded!");
      console.log(loadedProjects);

      const cleanedProjects = cleanProjects(loadedProjects);
      const sortedProjects = [...cleanedProjects].sort((a, b) =>
        a.year.substring(a.year.length - 4) < b.year.substring(b.year.length - 4) ? 1 : -1
      );

      setProjects(sortedProjects);
    }
    loadBgImage();
    loadProjects();
  }, []);

  function cleanProjects(loadedProjects) {
    var cleanedProjects = [];
    for (var i = 0; i < loadedProjects.length; i++) {
      const rawType =
        loadedProjects[i].acf.type ||
        loadedProjects[i].acf.projectType ||
        loadedProjects[i].acf.project_type;

      const newProjectObject = {
        title: loadedProjects[i].title.rendered,
        abstract: loadedProjects[i].acf.projectAbstract,
        year: loadedProjects[i].acf.year,
        location: loadedProjects[i].acf.location,
        quote: loadedProjects[i].acf.quote,
        credits: loadedProjects[i].acf.credits,
        role: loadedProjects[i].acf.role,
        type: loadedProjects[i].acf.type,

        images: [
          loadedProjects[i].acf.image1,
          loadedProjects[i].acf.image2,
          loadedProjects[i].acf.image3,
          loadedProjects[i].acf.image4,
          loadedProjects[i].acf.image5,
          loadedProjects[i].acf.image6,
        ],
        mobileImages: [
          loadedProjects[i].acf.mobileimage1,
          loadedProjects[i].acf.mobileimage2,
        ].filter(Boolean),
      };
      cleanedProjects.push(newProjectObject);
    }
    return cleanedProjects;
  }

  function showAbout(e) {
    e.stopPropagation();
    aboutRef.current.style.display = "flex";
    menuRef.current.style.display = "none";
  }

  function hideAbout(e) {
    e.stopPropagation();

    aboutRef.current.style.display = "none";
  }

  function showMenu(e) {
    e.stopPropagation();

    menuRef.current.style.display = "flex";
  }

  function hideMenu(e) {
    e.stopPropagation();
    menuRef.current.style.display = "none";
    // aboutExtendedRef.current.innerHTML = "+ read more";
  }

  function showAboutExtended(e) {
    e.stopPropagation();
    aboutExtendedRef.current.innerHTML =
      "As a set designer, she has assisted Isabelle Krötsch (Kammerspiele, Munich), Anna Fleischle (Apollo Theatre, London), Loren Elstein (The Welsh National Opera, Cardiff), and Laura Hopkins (Leeds Playhouse, Leeds), among others. In 2019, Nina made her Edinburgh Festival Fringe debut with the devised play ‘The Ship Sank. Where on Deck Did My Captain Lie?’, which was awarded the Goethe Institute’s Support for Newcomer Talent. <br /> <br /> Nina is currently an interdisciplinary PhD researcher at Goldsmiths, University of London, working across the Department of Politics and the Department of Theatre and Performance. Her research explores themes of female revenge in contemporary performance. ";
  }

  return (
    <div>
      <MobileWrapper>
        <Header onClick={showMenu}>Nina Kunzendorf</Header>
        {projects.map((item, key) => (
          <Link
            to="/projectMobile"
            style={{ textDecoration: "none" }}
            state={{ project: projects[key] }}
          >
            <Project>
              <img
                src={(() => {
                  const pool = item.mobileImages.length
                    ? item.mobileImages
                    : item.images;
                  return pool[Math.floor(Math.random() * pool.length)];
                })()}
                alt={item.title}
                style={{ width: "100vw", height: "100%", objectFit: "cover" }}
              />
              <TitleContainer>
                <TitleText>{item.title}</TitleText>
              </TitleContainer>
            </Project>
          </Link>
        ))}
        <MenuContainer
          onClick={hideMenu}
          ref={menuRef}
          style={{ display: "none" }}
        >
          <MenuItem>
            <MenuItemText onClick={showAbout}>About</MenuItemText>
          </MenuItem>
          <MenuItem>
            <MenuItemText
              as="a"
              href="mailto:ninakunzendorf@gmail.com"
              style={{ textDecoration: "none", color: "white" }}
            >
              Contact
            </MenuItemText>
          </MenuItem>
          {/* <MenuItem onClick={showAbout}>
            <MenuItemText>About</MenuItemText>
          </MenuItem>
          <MenuItem>
            <MenuItemText>Contact</MenuItemText>
          </MenuItem>
          <MenuItem>
            <MenuItemText>Nina Kunzendorf</MenuItemText>
          </MenuItem> */}
        </MenuContainer>
        <About ref={aboutRef} onClick={hideAbout}>
          {" "}
          Nina Kunzendorf is a theatre-maker and
          researcher with a background in performance design. Her practice
          explores experimental and unconventional forms of dramatic expression.
          Based in London, Nina has worked on projects across theatre, opera,
          dance, visual arts, and film.
          
          <AboutExtended ref={aboutExtendedRef} onClick={showAboutExtended}>
            + read more
          </AboutExtended>
        </About>
      </MobileWrapper>
    </div>
  );
}
